import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppClientsPage.';
  public static readonly clientPluralTitle = `${Id.prefix}clientPluralTitle`;
  public static readonly clientPluralPageDescription = `${Id.prefix}clientPluralPageDescription`;
}

export class LangAppClientsPage {
  private constructor() {}
  public static clientPluralTitle(): string {
    return interpolate(Id.clientPluralTitle);
  }
  public static clientPluralPageDescription(): string {
    return interpolate(Id.clientPluralPageDescription);
  }
}

export class AppClientsPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.clientPluralTitle, "{{glossary 'client:plural'}}", 'Title for the clients page (plural)');
    register.add(
      Id.clientPluralPageDescription,
      "{{glossary 'client:plural'}} page",
      'Description for the clients page (plural)'
    );
  }
}
